import './ContainerA.css'
import { useEffect,useState } from 'react';

const ContainerA=()=>{

  const [count, setCount] = useState(0);
  const targetCount = 1200;
  const duration = 2000; 

  // Effect for the count-up animation
  useEffect(() => {
    let startTimestamp;
    const step = (timestamp) => {
      if (!startTimestamp) startTimestamp = timestamp;
      const progress = timestamp - startTimestamp;
      const currentCount = Math.min(Math.floor((progress / duration) * targetCount), targetCount);
      setCount(currentCount);

      if (progress < duration) {
        window.requestAnimationFrame(step);
      }
    };

    
    window.requestAnimationFrame(step);
  }, []); 
return(
    <div className='ContainerA-main-div'>
    <div className='container-a-div'>
    <div className='div-1'>
  <h3>Intern Buddy</h3>
  <div className='container-flex-div'>
    <span className='purpose'>We open the door to thrilling internship possibilities across diverse industries. Explore and kickstart your career journey with us.</span>
    
    <span className='count-up-container'>
                <span className='count-up'>{count.toLocaleString()}+</span>
                <span className='count-up-label'>internship letters</span>
              </span>

    <span className='btn-form'><span className='animated-hand'>👉</span> <a href='/request-for-letter'>Request for letter</a></span>
  </div>
</div>
    <div className='letter'> <img src='./internship-sample-blurred.svg' alt='ghabsalogo' width='178px' height='104px' /></div>
    </div>
    </div>
)
}
export default ContainerA;